import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=7d44980d&"
import script from "./Confirmation.vue?vue&type=script&lang=js&"
export * from "./Confirmation.vue?vue&type=script&lang=js&"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=7d44980d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.vlaams-brabant/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BAlert, BFormTextarea, BCol, BFormSelect, BFormInput, BButton, BFormFile, BRow, BCard, BForm, BContainer} from 'bootstrap-vue'
    installComponents(component, {BAlert, BFormTextarea, BCol, BFormSelect, BFormInput, BButton, BFormFile, BRow, BCard, BForm, BContainer})
    

export default component.exports